import environment from "@/modules/environment";
import { getAppValue } from "@/utils/getAppValue";

type ComparisonItem = {
  string: string;
  includedInFreeVersion: boolean;
  includedInPremiumVersion: boolean;
  freeStringKey?: string;
  premiumStringKey?: string;
  description?: string;
  imgSrc?: string;
  videoSrc?: string;
};

const { isBarkio, isBibino, isCamerito } = environment;

const premiumOnly = {
  includedInFreeVersion: false,
  includedInPremiumVersion: true
};

const cameritoComparsionEnum = [
  {
    string: "pricing.comparison.platformSupport",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.pushToTalk",
    description: "pricing.comparision.pushToTalk.description",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.continuousStream",
    description: "pricing.comparison.continuousStream.description",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.features.motion",
    description: "pricing.comparison.motion.description",
    /* imgSrc: "pricing-motion", */
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.lowLight",
    description: "pricing.comparison.lowLight.description",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.multiparent",
    freeStringKey: "unlimited",
    premiumStringKey: "unlimited"
  },
  {
    string: "pricing.comparison.multiBaby",
    freeStringKey: "pricing.upTo",
    premiumStringKey: "unlimited"
  },
  {
    string: "pricing.comparison.audioDetection",
    description: "pricing.comparison.audioDetection.description",
    videoSrc: "noise.webm",
    includedInFreeVersion: false,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.livestreamHistory",
    description: "pricing.comparison.livestreamHistory.description",
    videoSrc: "replay.webm",
    includedInFreeVersion: false,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.features.noAds",
    ...premiumOnly
  },
  {
    string: "pricing.comparison.hdQuality",
    description: "pricing.comparison.hdQuality.description",
    ...premiumOnly
  },
  {
    string: "pricing.comparison.twoWay",
    description: "pricing.comparison.twoWay.description",
    videoSrc: "twoWay.webm",
    ...premiumOnly
  },
  {
    string: "pricing.comparison.eventsStorage",
    ...premiumOnly,
    freeStringKey: "pricing.1day",
    premiumStringKey: "pricing.21days"
  },
  {
    string: "pricing.comparison.zoom",
    description: "pricing.comparison.zoom.description",
    videoSrc: "zoom.webm",
    ...premiumOnly
  }
] as ComparisonItem[];

const commonComparisonEnum = [
  {
    string: "pricing.comparison.unlimitedAudio",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },

  {
    string: "pricing.comparison.platformSupport",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.pushToTalk",
    includedInFreeVersion: true,
    includedInPremiumVersion: true
  },
  {
    string: "pricing.comparison.unlimitedVideo",
    ...premiumOnly
  },
  {
    string: "pricing.features.noAds",
    ...premiumOnly
  },
  {
    string: "pricing.features.motion",
    description: "pricing.comparison.motion.description",
    imgSrc: "pricing-motion.jpg",
    ...premiumOnly
  },
  {
    string: "pricing.comparison.soundsAndVideos",
    description: "pricing.comparison.soundsAndVideos.description",
    imgSrc: "pricing-record.jpg",
    ...premiumOnly
  },
  ...(isBibino
    ? [
        {
          string: "features.lullaby.h4sm",
          description: "pricing.comparison.lullaby.description",
          imgSrc: "pricing-lullabies.jpg",
          ...premiumOnly
        }
      ]
    : []),
  {
    string: "pricing.comparison.customize",
    description: "pricing.comparison.customize.description",
    imgSrc: "pricing-avatar.jpg",
    ...premiumOnly
  },

  ...getAppValue({
    bibino: [
      {
        string: "pricing.comparison.nightMode",
        description: "pricing.comparison.nightMode.description",
        imgSrc: "pricing-nightmode.jpg",
        ...premiumOnly
      }
    ],
    barkio: [
      {
        string: "pricing.comparison.scheduler",
        description: "pricing.comparison.scheduler.description",
        imgSrc: "pricing-scheduler.jpg",
        ...premiumOnly
      }
    ],
    camerito: []
  }),

  ...(isBarkio
    ? [
        {
          string: "pricing.comparison.commands",
          description: "pricing.comparison.commands.description",
          imgSrc: "pricing-commands.jpg",
          ...premiumOnly
        }
      ]
    : []),

  {
    string: "pricing.comparison.multiBaby",
    description: "pricing.comparison.multiBaby.description",
    imgSrc: "pricing-multibaby.jpg",
    ...premiumOnly
  },
  {
    string: "pricing.comparison.multiparent",
    description: "pricing.comparison.multiparent.description",
    imgSrc: "pricing-multiperson.jpg",
    ...premiumOnly
  },
  ...(isBibino
    ? [
        {
          string: "pricing.comparison.pictureinpicture",
          description: "pricing.comparison.pictureinpicture.description",
          videoSrc: "pricing-pip.webm",
          ...premiumOnly
        }
      ]
    : []),
  {
    string: "pricing.features.mute",
    description: "pricing.features.mute.description",
    imgSrc: "pricing-mute.jpg",
    ...premiumOnly
  }
] as ComparisonItem[];
const comparisonEnum = isCamerito ? cameritoComparsionEnum : commonComparisonEnum;

export { comparisonEnum };
